export default __webpack_public_path__ + "static/media/footer-logo.67ac7888.png";